import { AdminAPI } from "@/api/AdminAPI";

export const adminModule = {
    state: () => ({
        personalData: ''
    }),
    getters: {
        personalData: state => state.personalData,
    },
    mutations: {
        setPersonalData(state, userData) {
            state.personalData = userData
        },
    },
    actions: {
        async getPersonalData({ commit }, userData){
            return await AdminAPI.getPersonalData(userData)
            .then(res => {
                commit("setPersonalData", res.data)
                return res.status;
            })
            .catch((error) => {
                return error.response.status;
            });
        },
        async updatePersonalData({ commit, state }, userData){
            return await AdminAPI.updatePersonalData(userData)
            .then((response) => {
                return response.status;
            })
            .catch((error) => {
                return error.response.status
            })
        }
    },
    namespaced: true
}